import { AccordionContent, AccordionTrigger, Accordion as ZapposAccordion, AccordionItem as ZapposAccordionItem } from '@mweb/zappos-ui/Accordion';

import useMartyContext from 'hooks/useMartyContext';

export interface AccordionProps {
  heading: string;
  children: React.ReactNode;
}

export const Accordion = ({ heading, children }: AccordionProps) => {
  const { testId } = useMartyContext();

  return (
    <ZapposAccordion key={`accordion-${heading}`} type="single" collapsible defaultValue={heading}>
      <ZapposAccordionItem value={heading}>
        <AccordionTrigger data-test-id={testId(`footerAccordionTrigger-${heading?.replace(/\s/g, '-')}`)}>{heading}</AccordionTrigger>
        <AccordionContent>{children}</AccordionContent>
      </ZapposAccordionItem>
    </ZapposAccordion>
  );
};
